export enum DialogType {
    Confirm,
    Alert
}